// extracted by mini-css-extract-plugin
export default {"tg_block":"telegram_tg_block__GP0Uw","tgid":"telegram_tgid__miCnv","nonce":"telegram_nonce__sQJkl"};